import { NavLink, Outlet } from "react-router-dom";
import PageHeader from "@/components/PageHeader";

export const AMI_SECTIONS = [
  { to: "", label: "Übersicht", end: true },
  { to: "live", label: "Live-Marktüberwachung" },
  { to: "historie", label: "Historische Marktanalyse" },
  { to: "intelligence", label: "Market Intelligence" },
  { to: "prognosen", label: "KI-Prognosen" },
  { to: "strategien", label: "Strategieentwicklung" },
  { to: "stop-loss", label: "Adaptive Stop-Loss" },
  { to: "backtesting", label: "Backtesting" },
  { to: "demo", label: "Demo-Trading", phase: 5 },
  { to: "live-trading", label: "Live-Trading", phase: 6 },
  { to: "risk", label: "Risk & Execution" },
  { to: "performance", label: "Performance & Learning", phase: 5 },
  { to: "verbindungen", label: "API-Verbindungen" },
  { to: "monitoring", label: "KI-Monitoring" },
  { to: "einstellungen", label: "Systemeinstellungen" },
];

export default function AmiLayout() {
  return (
    <div data-testid="ami-layout" className="min-w-0 max-w-full overflow-x-hidden">
      <PageHeader
        eyebrow="Algorithmic Market Intelligence · Phase 4"
        title="AMI"
        description="Deine persönliche Grundlage für datenbasierte Trading-Intelligenz. Nur für dich sichtbar. Live-Trading ist gesperrt."
      />
      <nav className="border-b border-border -mx-5 md:-mx-10 px-5 md:px-10 mb-8" aria-label="AMI-Bereiche" data-testid="ami-subnav">
        <div className="flex items-center gap-1 overflow-x-auto">
          {AMI_SECTIONS.map((s) => (
            <NavLink
              key={s.to}
              to={s.to ? `/app/ami/${s.to}` : "/app/ami"}
              end={s.end}
              data-testid={`ami-nav-${s.to || "overview"}`}
              className={({ isActive }) =>
                `relative px-3 py-3 text-sm whitespace-nowrap transition-colors ${isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"}`
              }
            >
              {({ isActive }) => (
                <>
                  <span className="inline-flex items-center gap-1.5">
                    {s.label}
                    {s.phase && <span className="text-[10px] font-mono text-muted-foreground/70">P{s.phase}</span>}
                  </span>
                  {isActive && <span className="absolute left-2 right-2 -bottom-px h-[2px] rounded-full bg-primary/90" aria-hidden />}
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
      <Outlet />
    </div>
  );
}
